module.exports = __webpack_public_path__ + "static/media/MO.fd520e31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MO.svg
// module id = 316
// module chunks = 0